module.exports = __webpack_public_path__ + "img/pumpimage.db6f392d.png";